// extracted by mini-css-extract-plugin
export default {"ListWrapper":"List_ListWrapper__OG6ho","scrolling":"List_scrolling__YD+kY","NoRecord":"List_NoRecord__awtER","open":"List_open__+Peif"};